export const theme = {
  colors: {
    background: "#ffffff",
    grey1: "#edededff",
    grey2: "#a2a2a2ff",
    text: "#2C2C2C",
    accent1: "#16AB3B",
    accent2: "#00630A",
    red: "#ed2f2fff",
  },
};
